module.exports = __webpack_public_path__ + "static/media/frame_67.9bc8a32c.jpg";